import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=ddc35c50&"
import script from "./ChatMessages.vue?vue&type=script&lang=js&"
export * from "./ChatMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports